export default __webpack_public_path__ + "static/media/handbook.78af7c22.png";